<template>
    <a-modal v-model:open="open" :title="modalTitle" @ok="handleOk" @cancel="handleCancel" :confirm-loading="confirmLoading">
        <a-form ref="formRef" :model="formState" layout="vertical">
            <!-- 行业 / 税种 字段 -->
            <template v-if="tabKey === 'industry' || tabKey === 'taxType'">
                <a-form-item label="编码" name="code" :rules="[{ required: true, message: '请输入编码' }]">
                    <a-input v-model:value="formState.code" placeholder="请输入编码" />
                </a-form-item>
                <a-form-item label="名称" name="name" :rules="[{ required: true, message: '请输入名称' }]">
                    <a-input v-model:value="formState.name" placeholder="请输入名称" />
                </a-form-item>
            </template>
            <!-- 涉税关键词 字段 -->
            <template v-if="tabKey === 'taxKeyword'">
                <a-form-item label="涉税关键词" name="keyword" :rules="[{ required: true, message: '请输入涉税关键词' }]">
                    <a-input v-model:value="formState.keyword" placeholder="请输入涉税关键词" />
                </a-form-item>
                <a-form-item label="关键词描述" name="description">
                    <a-textarea v-model:value="formState.description" placeholder="请输入关键词描述" :rows="3" />
                </a-form-item>
            </template>
            <a-form-item label="排序" name="sort">
                <a-input-number v-model:value="formState.sort" :min="0" style="width: 100%" />
            </a-form-item>
            <a-form-item label="状态" name="status" :rules="[{ required: true, message: '请选择状态' }]">
                <a-select v-model:value="formState.status" placeholder="请选择状态">
                    <a-select-option value="正常">正常</a-select-option>
                    <a-select-option value="停用">停用</a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import {
    saveIndustry, updateIndustry,
    saveTaxType, updateTaxType,
    saveTaxKeyword, updateTaxKeyword
} from '@/api/service';
import { message } from 'ant-design-vue';
import { ref, reactive, computed } from 'vue';

const saveMap = {
    industry: saveIndustry,
    taxType: saveTaxType,
    taxKeyword: saveTaxKeyword,
};

const updateMap = {
    industry: updateIndustry,
    taxType: updateTaxType,
    taxKeyword: updateTaxKeyword,
};

const tabLabels = {
    industry: '行业',
    taxType: '税种',
    taxKeyword: '涉税关键词'
};

export default {
    name: 'AddDictComponent',
    props: {
        tabKey: {
            type: String,
            default: 'industry'
        }
    },
    emits: ['saved'],
    setup(props, { emit }) {
        const open = ref(false);
        const confirmLoading = ref(false);
        const formRef = ref(null);
        const editId = ref(null);
        const formState = reactive({
            code: '',
            name: '',
            keyword: '',
            description: '',
            sort: 0,
            status: '正常'
        });

        const modalTitle = computed(() => {
            const label = tabLabels[props.tabKey] || '字典';
            return editId.value ? `修改${label}` : `添加${label}`;
        });

        const handleOk = async () => {
            try {
                await formRef.value?.validate();
            } catch {
                return;
            }
            confirmLoading.value = true;
            try {
                const isEdit = !!editId.value;
                const api = isEdit ? updateMap[props.tabKey] : saveMap[props.tabKey];
                const params = { ...formState };
                if (isEdit) {
                    params.id = editId.value;
                }
                // 只传当前 tab 相关的字段
                if (props.tabKey === 'industry' || props.tabKey === 'taxType') {
                    delete params.keyword;
                    delete params.description;
                } else {
                    delete params.code;
                    delete params.name;
                }
                const response = await api(params);
                if (response.code === 200) {
                    message.success(isEdit ? '修改成功' : '添加成功');
                    open.value = false;
                    emit('saved');
                    resetForm();
                } else {
                    message.error(response.msg || '操作失败');
                }
            } finally {
                confirmLoading.value = false;
            }
        };

        const handleCancel = () => {
            resetForm();
            open.value = false;
        };

        const resetForm = () => {
            formRef.value?.resetFields();
            editId.value = null;
            formState.code = '';
            formState.name = '';
            formState.keyword = '';
            formState.description = '';
            formState.sort = 0;
            formState.status = '正常';
        };

        const openEdit = (record) => {
            editId.value = record.id;
            if (props.tabKey === 'industry' || props.tabKey === 'taxType') {
                formState.code = record.code || '';
                formState.name = record.name || '';
            } else {
                formState.keyword = record.keyword || '';
                formState.description = record.description || '';
            }
            formState.sort = record.sort ?? 0;
            formState.status = record.status || '正常';
            open.value = true;
        };

        return {
            open,
            confirmLoading,
            formRef,
            formState,
            editId,
            modalTitle,
            handleOk,
            handleCancel,
            openEdit,
        };
    },
};
</script>
<style></style>
